import React, { useState } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setAgreement } from '../../store/action';
import { AppRoute } from '../../const';
import styles from './cookie.module.scss';

function Cookie() {

	const dispatch = useDispatch();

	const isAgree = useSelector((state) => state.isAgree);

	const handleAgreeClick = () => {
		dispatch(setAgreement(false));
	};

	return (
		<div >
			{
				isAgree &&
				<div className={styles.wrapper_cookie}>
					<div className={cn(styles.privacy, 'container')}>
						<p>Этот сайт использует файлы cookie. Мы используем их для обеспечения корректной работы сайта и анализа трафика. Продолжая использовать сайт, вы соглашаетесь с нашей <Link to={AppRoute.COOKIE} className={styles.link}>Политикой в отношении файлов cookie</Link> и <Link to={AppRoute.PRIVACY} className={styles.link}>Политикой конфиденциальности</Link>.</p>
						<button
							type='button'
							// onClick={() => setIsAgree(false)}
							onClick={handleAgreeClick}
							className={styles.button}
						>Принять
						</button>
					</div>
				</div>
			}
		</div >
	);
}

export default Cookie;



